"use strict";
var defineBuiltIn = require("../internals/define-built-in");
var errorToString = require("../internals/error-to-string");
var ErrorPrototype = Error.prototype;
if (ErrorPrototype.toString !== errorToString) {
  defineBuiltIn(ErrorPrototype, "toString", errorToString);
}
